import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button} from '@salesforce/retail-react-app/app/components/shared/ui'
import {CustomClose, LeftArrow} from '../../icons/index'

const QuickViewCloseButton = ({
    styles,
    setIsQuickViewOpen,
    onQuickViewClose,
    showBackButton = false,
    onBack
}) => {
    const sharedButtonVisualStyles = {
        backgroundColor: styles?.closeButtonContainer?.backgroundColor,
        opacity: styles?.closeButtonContainer?.opacity,
        height: styles?.closeButtonContainer?.height,
        filter: styles?.closeButtonContainer?.filter
    }

    return (
        <Box
            {...styles.closeButtonContainer}
            {...(showBackButton && {
                left: 4,
                right: 4,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: 'transparent',
                opacity: 1,
                filter: 'none'
            })}
        >
            {showBackButton ? (
                <Button
                    variant="link"
                    aria-label="Back"
                    {...sharedButtonVisualStyles}
                    px="4px"
                    width="24px"
                    minWidth="24px"
                    onClick={() => {
                        if (onBack) {
                            onBack()
                            return
                        }
                        setIsQuickViewOpen(false)
                    }}
                >
                    <LeftArrow data-testid="left-arrow-icon" width="18px" height="15px" />
                </Button>
            ) : null}
            <Button
                variant="link"
                position={{base: 'absolute', lg: 'static'}}
                right={{base: 4, lg: 'auto'}}
                top={{base: 4, lg: 'auto'}}
                aria-label="Close"
                {...(showBackButton ? sharedButtonVisualStyles : {})}
                onClick={() => {
                    setIsQuickViewOpen(false)
                    onQuickViewClose?.()
                }}
            >
                <CustomClose />
            </Button>
        </Box>
    )
}

QuickViewCloseButton.propTypes = {
    styles: PropTypes.object,
    setIsQuickViewOpen: PropTypes.func,
    onQuickViewClose: PropTypes.func,
    showBackButton: PropTypes.bool,
    onBack: PropTypes.func
}

export default QuickViewCloseButton
